import { ActivatedRoute } from '@angular/router';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { CommonService } from './../../core/services/common.service';
import { FormService } from './../../core/services/form.service';
import { Component, OnInit, ViewChild } from '@angular/core';

class CandidateDetails {
  name: string;
  track_id: string;
  email: string;
  mobile_number: string;
  company_name: string;
}

@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.css']
})
export class ConsentFormComponent implements OnInit {

  candidate: CandidateDetails
  signature: any;
  isSignatureAdded = false;
  formData = new FormData();
  consentSubmitted = false;
  consentAlreadySubmitted = false;
  consentToken;
  isFormSubmitted = false;

  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  constructor(
    private formService: FormService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {

      this.consentToken = params['token'];
      this.formService.getConsentForm(this.consentToken).subscribe(
        response => {
          if (response.active == 0) {
            this.commonService.notifications.warn('Warning', 'Consent Already Recorded');
            this.consentAlreadySubmitted = true;
          } else {
            this.consentAlreadySubmitted = false;
            this.consentSubmitted = false;
            this.isSignatureAdded = false;
            this.isFormSubmitted = false;
            this.candidate = response;
          }
        },
        error => {

          this.commonService.notifications.error('error', 'Invalid Link');

        }
      )
    })
  }

  ngAfterViewInit() {
    // this.signaturePad is now available
    if (this.signaturePad) {
      this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    // console.log(this.signaturePad.toDataURL());
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    // console.log('begin drawing');
  }

  clear() {
    this.signaturePad.clear();
    this.isSignatureAdded = false;
  }

  save() {
    if (this.signaturePad.isEmpty()) {
      return alert('Please provide a signature first.');
    }

    this.signature = this.b64toBlob(this.signaturePad.toDataURL());

    this.formData.append('signature', this.signature);

    this.isSignatureAdded = true;

    this.commonService.notifications.success('Signature saved successfully');
  }

  b64toBlob(dataURI) {

    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/png' });
  }

  submitConsentForm(): void {
    // todo send request to backend
    this.isFormSubmitted = true;

    this.formService.uploadConsentForm(this.consentToken, this.formData).subscribe(
      response => {
        if (response.status == 'successfully_submitted') {
          this.consentSubmitted = true;
          this.commonService.notifications.success('Consent Submitted Successfully');
        } else {
          this.consentAlreadySubmitted = true;
          this.commonService.notifications.warn('Warning', 'Consent Already Recorded');
        }
      },
      error => {
        this.commonService.notifications.error('File Upload Failed');
      }
    );

  }

  private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 0.5,
    'canvasWidth': 300,
    'canvasHeight': 200,
    'backgroundColor': 'rgb(211,211,211)'
  };
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/consent-form/consent-form.component.ts